/*
 * TFX Featured Collection
 * Objective: shared interaction controller for sections/tfx-featured-collection.liquid.
 * Scope: home + product pages rendering sections/tfx-featured-collection.liquid via [data-tfx-fc-controller="shared"].
 * Dependencies: section data attributes, carousel-slider (Symmetry), tfx-collection-overlay-refresh.js.
 * Date: 2026-03-11
 * Rollback: remove this file include from layout/theme.liquid and restore the section-local JS block.
 */
/* BEGIN TFX_FC_DYNAMIC_RELATED_JS
   Objective: allow TFX FC section to load Shopify dynamic product recommendations on product pages.
   Scope: sections/tfx-featured-collection.liquid (opt-in via section setting).
   Rollback: disable setting "TFX: Use dynamic related products on product pages" or remove this BEGIN/END block.
*/
(function() {
  if (window.__tfxFcDynamicRelatedBooted) { return; }
  window.__tfxFcDynamicRelatedBooted = true;

  var findDynamicSection = function(sectionId) {
    if (!sectionId) { return null; }
    return document.querySelector('[data-section-id="' + sectionId + '"][data-tfx-fc-controller="shared"][data-tfx-fc-dynamic-related]');
  };

  var getAllDynamicSections = function() {
    return document.querySelectorAll('[data-tfx-fc-controller="shared"][data-tfx-fc-dynamic-related]');
  };

  var loadDynamicRecommendations = function(sectionElement, forceReload) {
    if (!sectionElement) { return; }
    if (sectionElement.getAttribute('data-tfx-fc-dynamic-related-enabled') !== 'true') { return; }
    if (!forceReload && sectionElement.dataset.tfxDynamicRelatedLoaded === 'true') { return; }
    if (sectionElement.dataset.tfxDynamicRelatedLoading === 'true') { return; }

    var requestUrl = sectionElement.getAttribute('data-tfx-fc-dynamic-related-url');
    if (!requestUrl) { return; }

    var targetContent = sectionElement.querySelector('[data-tfx-fc-dynamic-related-content]');
    if (!targetContent) { return; }

    sectionElement.dataset.tfxDynamicRelatedLoading = 'true';

    fetch(requestUrl, { credentials: 'same-origin' })
      .then(function(response) {
        if (!response.ok) { return ''; }
        return response.text();
      })
      .then(function(html) {
        if (!html) { return; }

        var container = document.createElement('div');
        container.innerHTML = html;

        var sectionId = sectionElement.getAttribute('data-section-id');
        var fetchedSection = null;
        if (sectionId) {
          fetchedSection = container.querySelector('[data-section-id="' + sectionId + '"][data-tfx-fc-controller="shared"][data-tfx-fc-dynamic-related]');
        }
        if (!fetchedSection) {
          fetchedSection = container.querySelector('[data-tfx-fc-controller="shared"][data-tfx-fc-dynamic-related]');
        }
        if (!fetchedSection) { return; }

        var fetchedContent = fetchedSection.querySelector('[data-tfx-fc-dynamic-related-content]');
        if (!fetchedContent) { return; }

        var fetchedMarkup = fetchedContent.innerHTML;
        var contentChanged = targetContent.innerHTML !== fetchedMarkup;
        var wasLoaded = sectionElement.dataset.tfxDynamicRelatedLoaded === 'true';

        if (contentChanged) {
          targetContent.innerHTML = fetchedMarkup;
        }
        sectionElement.dataset.tfxDynamicRelatedLoaded = 'true';

        if (contentChanged || !wasLoaded) {
          var carouselElement = sectionElement.querySelector('carousel-slider');
          if (carouselElement && typeof carouselElement.refresh === 'function') {
            carouselElement.refresh();
          }
          if (sectionId && typeof window.tfxReinitFeaturedCollectionInteractive === 'function') {
            window.tfxReinitFeaturedCollectionInteractive(sectionId);
          }
          if (sectionId && typeof window.tfxInitFeaturedCollectionPresentation === 'function') {
            window.tfxInitFeaturedCollectionPresentation(sectionId);
          }
        }
      })
      .catch(function() {})
      .then(function() {
        sectionElement.dataset.tfxDynamicRelatedLoading = 'false';
      });
  };

  window.tfxInitFcDynamicRelatedSection = function(sectionId, forceReload) {
    var sectionElement = findDynamicSection(sectionId);
    loadDynamicRecommendations(sectionElement, !!forceReload);
  };

  getAllDynamicSections().forEach(function(sectionElement) {
    loadDynamicRecommendations(sectionElement, false);
  });

  if (!window.__tfxFcDynamicRelatedEditorEventsBound) {
    document.addEventListener('shopify:section:load', function(event) {
      if (!event.detail || !event.detail.sectionId) { return; }
      window.tfxInitFcDynamicRelatedSection(event.detail.sectionId, true);
    });

    document.addEventListener('shopify:section:select', function(event) {
      if (!event.detail || !event.detail.sectionId) { return; }
      window.tfxInitFcDynamicRelatedSection(event.detail.sectionId, false);
    });

    window.__tfxFcDynamicRelatedEditorEventsBound = true;
  }
})();
/* END TFX_FC_DYNAMIC_RELATED_JS */

/* BEGIN TFX_FC_INLINE_COLLECTION_SWITCH_JS
   Objective: on homepage, switch the displayed collection inside TFX FC without navigating away.
   Scope: [data-tfx-fc-inline-switch-enabled="true"] sections only.
   Rollback: remove this BEGIN/END block and matching Liquid BEGIN/END block.
*/
(function() {
  if (window.__tfxFcInlineCollectionSwitchBooted) { return; }
  window.__tfxFcInlineCollectionSwitchBooted = true;

  var switchState = window.__tfxFcInlineSwitchState || {};
  window.__tfxFcInlineSwitchState = switchState;
  var CONFIG = {
    maxCacheEntries: 8,
    prefetchLimit: 2,
    prefetchEagerCount: 0,
    prefetchIdleTimeout: 1200,
    prefetchFallbackDelay: 420
  };

  var getSectionState = function(sectionId) {
    if (!sectionId) { return null; }
    if (!switchState[sectionId]) {
      switchState[sectionId] = {
        cache: {},
        cacheOrder: [],
        prefetching: {},
        requestSeq: 0,
        controller: null
      };
    }
    return switchState[sectionId];
  };

  var findSection = function(sectionId) {
    if (!sectionId) { return null; }
    return document.querySelector('[data-section-id="' + sectionId + '"][data-tfx-fc-controller="shared"]');
  };

  var getAllSections = function() {
    return document.querySelectorAll('[data-tfx-fc-controller="shared"]');
  };

  var isInlineSwitchEnabled = function(sectionElement) {
    if (!sectionElement) { return false; }
    return sectionElement.getAttribute('data-tfx-fc-inline-switch-enabled') === 'true';
  };

  var shouldSkipPrefetch = function() {
    if (document.visibilityState === 'hidden') { return true; }
    var connection = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
    if (!connection) { return false; }
    if (connection.saveData === true) { return true; }
    var effectiveType = (connection.effectiveType || '').toLowerCase();
    return effectiveType === 'slow-2g' || effectiveType === '2g';
  };

  var getSwitchTarget = function(event) {
    if (!event || !event.target || !event.target.closest) { return null; }
    var trigger = event.target.closest('[data-tfx-fc-switch-collection]');
    if (!trigger) { return null; }

    var sectionElement = trigger.closest('[data-tfx-fc-controller="shared"]');
    if (!isInlineSwitchEnabled(sectionElement)) { return null; }

    var collectionHandle = trigger.getAttribute('data-tfx-fc-switch-collection');
    if (!collectionHandle) { return null; }

    return {
      sectionElement: sectionElement,
      collectionHandle: collectionHandle,
      collectionUrl: trigger.getAttribute('href')
    };
  };

  var parseFetchedSection = function(html, sectionId) {
    if (!html) { return null; }
    var container = document.createElement('div');
    container.innerHTML = html;

    var fetchedSection = null;
    if (sectionId) {
      fetchedSection = container.querySelector('[data-section-id="' + sectionId + '"][data-tfx-fc-controller="shared"]');
    }
    if (!fetchedSection) {
      fetchedSection = container.querySelector('[data-tfx-fc-controller="shared"]');
    }
    return fetchedSection;
  };

  var buildRequestUrl = function(baseHref, sectionId, collectionHandle, omitCollectionParam) {
    if (!sectionId || !collectionHandle) { return null; }
    var requestUrl = new URL(baseHref, window.location.origin);
    requestUrl.searchParams.set('section_id', sectionId);
    if (omitCollectionParam) {
      requestUrl.searchParams.delete('tfx_fc_collection');
    } else {
      requestUrl.searchParams.set('tfx_fc_collection', collectionHandle);
    }
    requestUrl.searchParams.set('tfx_fc_inline_switch', '1');
    return requestUrl;
  };

  var contentHasProductCards = function(contentRoot) {
    if (!contentRoot || !contentRoot.querySelector) { return false; }
    return !!contentRoot.querySelector('.product-grid .product-block');
  };

  var contentHasVisibleProductCards = function(contentRoot) {
    if (!contentRoot || !contentRoot.querySelector) { return false; }
    var sliderItems = contentRoot.querySelectorAll('.product-grid .slider__item');
    if (!sliderItems.length) {
      return contentHasProductCards(contentRoot);
    }
    for (var i = 0; i < sliderItems.length; i += 1) {
      if (sliderItems[i].hasAttribute('hidden')) { continue; }
      if (sliderItems[i].querySelector('.product-block')) { return true; }
    }
    return false;
  };

  var markupHasProductCards = function(markup) {
    if (typeof markup !== 'string' || markup === '') { return false; }
    return markup.indexOf('product-grid') !== -1 && markup.indexOf('product-block') !== -1;
  };

  var sectionHasRenderableProductCards = function(sectionElement) {
    if (!sectionElement || !sectionElement.querySelector) { return false; }
    var contentRoot = sectionElement.querySelector('[data-tfx-fc-dynamic-related-content]');
    if (!contentRoot) { return false; }
    return contentHasVisibleProductCards(contentRoot);
  };

  var sectionHasVisibleCardInViewport = function(sectionElement) {
    if (!sectionElement || !sectionElement.querySelector) { return false; }
    var track = getCarouselTrack(sectionElement);
    if (!track) { return sectionHasRenderableProductCards(sectionElement); }
    var trackRect = track.getBoundingClientRect();
    if (!trackRect || trackRect.width < 2) { return sectionHasRenderableProductCards(sectionElement); }

    var items = track.querySelectorAll('.slider__item');
    if (!items.length) {
      return !!track.querySelector('.product-block');
    }

    for (var i = 0; i < items.length; i += 1) {
      if (items[i].hasAttribute('hidden')) { continue; }
      var measured = getMeasuredSlideElement(items[i]);
      var rect = measured ? measured.getBoundingClientRect() : items[i].getBoundingClientRect();
      if (rect.right > (trackRect.left + 1) && rect.left < (trackRect.right - 1)) {
        return true;
      }
    }
    return false;
  };

  var isDefaultCollectionHandle = function(sectionElement, collectionHandle) {
    if (!sectionElement || !collectionHandle) { return false; }
    var defaultHandle = sectionElement.getAttribute('data-tfx-fc-default-collection-handle') || '';
    return defaultHandle === collectionHandle;
  };

  var setCachedMarkup = function(state, collectionHandle, markup) {
    if (!state || !collectionHandle || typeof markup !== 'string') { return; }
    if (!markupHasProductCards(markup)) { return; }

    var cacheIndex = state.cacheOrder.indexOf(collectionHandle);
    if (cacheIndex !== -1) {
      state.cacheOrder.splice(cacheIndex, 1);
    }
    state.cacheOrder.push(collectionHandle);
    state.cache[collectionHandle] = markup;

    if (state.cacheOrder.length > CONFIG.maxCacheEntries) {
      var oldestHandle = state.cacheOrder.shift();
      if (oldestHandle) {
        delete state.cache[oldestHandle];
      }
    }
  };

  var getCachedMarkup = function(state, collectionHandle) {
    if (!state || !collectionHandle) { return null; }
    return state.cache[collectionHandle] || null;
  };

  var updateSelectorActiveState = function(sectionElement, collectionHandle) {
    if (!sectionElement || !collectionHandle) { return; }
    var triggers = sectionElement.querySelectorAll('[data-tfx-fc-switch-collection]');
    for (var i = 0; i < triggers.length; i += 1) {
      var triggerHandle = triggers[i].getAttribute('data-tfx-fc-switch-collection');
      if (triggerHandle === collectionHandle) {
        triggers[i].setAttribute('aria-current', 'page');
      } else {
        triggers[i].removeAttribute('aria-current');
      }
    }
  };

  var getSelectorScroller = function(rootElement) {
    if (!rootElement || !rootElement.querySelector) { return null; }
    return rootElement.querySelector('.tfx-fc-related-links.related-collection-links--buttons');
  };

  var getSideNav = function(sectionElement) {
    if (!sectionElement || !sectionElement.querySelector) { return null; }
    return sectionElement.querySelector('[data-tfx-fc-side-nav]');
  };

  var getCarouselTrack = function(sectionElement) {
    if (!sectionElement || !sectionElement.querySelector) { return null; }
    return sectionElement.querySelector('[data-tfx-fc-overlay-root].slider');
  };

  var resetCarouselToStart = function(sectionElement) {
    var track = getCarouselTrack(sectionElement);
    if (!track) { return; }
    track.scrollLeft = 0;
    if (typeof track.scrollTo === 'function') {
      track.scrollTo({ left: 0, behavior: 'auto' });
    }
  };

  var setSideNavButtonState = function(button, disabled) {
    if (!button) { return; }
    if (disabled) {
      button.setAttribute('disabled', 'disabled');
    } else {
      button.removeAttribute('disabled');
    }
  };

  var getMeasuredSlideElement = function(slideElement) {
    if (!slideElement || !slideElement.querySelector) { return slideElement; }
    return slideElement.querySelector('.tfx-fc-card-wrap') || slideElement.querySelector('.product-block') || slideElement.firstElementChild || slideElement;
  };

  var getTrackOverflowState = function(track) {
    var state = {
      hasOverflow: false,
      firstFullyVisible: true,
      lastFullyVisible: true,
      visibleSlideCount: 0
    };
    if (!track || !track.querySelector) { return state; }

    var slides = track.querySelectorAll('.slider__item:not([hidden])');
    state.visibleSlideCount = slides.length;
    if (!slides.length) { return state; }

    var trackRect = track.getBoundingClientRect();
    if (!trackRect || trackRect.width < 2) {
      state.hasOverflow = slides.length > 1;
      state.firstFullyVisible = false;
      state.lastFullyVisible = slides.length < 2;
      return state;
    }

    var tolerance = 1;
    var firstMeasured = getMeasuredSlideElement(slides[0]);
    var lastMeasured = getMeasuredSlideElement(slides[slides.length - 1]);
    var firstRect = firstMeasured ? firstMeasured.getBoundingClientRect() : slides[0].getBoundingClientRect();
    var lastRect = lastMeasured ? lastMeasured.getBoundingClientRect() : slides[slides.length - 1].getBoundingClientRect();

    state.firstFullyVisible = firstRect.left >= (trackRect.left - tolerance) && firstRect.right <= (trackRect.right + tolerance);
    state.lastFullyVisible = lastRect.left >= (trackRect.left - tolerance) && lastRect.right <= (trackRect.right + tolerance);
    state.hasOverflow = !(state.firstFullyVisible && state.lastFullyVisible);
    return state;
  };

  var updateSideNavState = function(sectionElement) {
    if (!sectionElement) { return; }
    var sideNav = getSideNav(sectionElement);
    var track = getCarouselTrack(sectionElement);
    if (!sideNav || !track || window.matchMedia('(max-width: 767.98px)').matches) { return; }

    var prevButton = sideNav.querySelector('[data-tfx-fc-nav="prev"]');
    var nextButton = sideNav.querySelector('[data-tfx-fc-nav="next"]');
    var carouselElement = sectionElement.querySelector('carousel-slider');
    if (carouselElement && carouselElement.hasAttribute('inactive')) {
      setSideNavButtonState(prevButton, true);
      setSideNavButtonState(nextButton, true);
      return;
    }

    var overflowState = getTrackOverflowState(track);
    if (overflowState.visibleSlideCount < 2) {
      setSideNavButtonState(prevButton, true);
      setSideNavButtonState(nextButton, true);
      return;
    }

    var canPrev = overflowState.hasOverflow && !overflowState.firstFullyVisible;
    var canNext = overflowState.hasOverflow && !overflowState.lastFullyVisible;

    setSideNavButtonState(prevButton, !canPrev);
    setSideNavButtonState(nextButton, !canNext);
  };

  var bindSideNav = function(sectionElement) {
    if (!sectionElement) { return; }
    var sectionId = sectionElement.getAttribute('data-section-id');
    if (!sectionId) { return; }
    var state = getSectionState(sectionId);
    if (!state) { return; }

    var sideNav = getSideNav(sectionElement);
    var track = getCarouselTrack(sectionElement);
    if (!sideNav || !track) {
      if (typeof state.unbindSideNav === 'function') {
        state.unbindSideNav();
        state.unbindSideNav = null;
      }
      updateSideNavState(sectionElement);
      return;
    }

    if (state.sideNavBoundTrack === track && state.sideNavBoundElement === sideNav) {
      updateSideNavState(sectionElement);
      return;
    }

    if (typeof state.unbindSideNav === 'function') {
      state.unbindSideNav();
      state.unbindSideNav = null;
    }

    var rafId = null;
    var settleTimerShort = null;
    var settleTimerLong = null;
    var resizeObserver = null;
    var onTrackScroll = function() {
      if (rafId) { return; }
      rafId = requestAnimationFrame(function() {
        rafId = null;
        updateSideNavState(sectionElement);
      });
    };

    track.addEventListener('scroll', onTrackScroll, { passive: true });

    if (typeof ResizeObserver !== 'undefined') {
      resizeObserver = new ResizeObserver(function() {
        updateSideNavState(sectionElement);
      });
      resizeObserver.observe(track);
      var trackGrid = track.querySelector('.slider__grid');
      if (trackGrid) {
        resizeObserver.observe(trackGrid);
      }
    }

    state.sideNavBoundTrack = track;
    state.sideNavBoundElement = sideNav;
    state.unbindSideNav = function() {
      track.removeEventListener('scroll', onTrackScroll);
      state.sideNavBoundTrack = null;
      state.sideNavBoundElement = null;
      if (resizeObserver) {
        resizeObserver.disconnect();
        resizeObserver = null;
      }
      if (rafId) {
        cancelAnimationFrame(rafId);
        rafId = null;
      }
      if (settleTimerShort) {
        clearTimeout(settleTimerShort);
        settleTimerShort = null;
      }
      if (settleTimerLong) {
        clearTimeout(settleTimerLong);
        settleTimerLong = null;
      }
    };

    updateSideNavState(sectionElement);
    settleTimerShort = setTimeout(function() {
      settleTimerShort = null;
      updateSideNavState(sectionElement);
    }, 120);
    settleTimerLong = setTimeout(function() {
      settleTimerLong = null;
      updateSideNavState(sectionElement);
    }, 520);
  };

  var normalizeSelectorButtons = function(rootElement) {
    var selectorScroller = getSelectorScroller(rootElement);
    if (!selectorScroller) { return; }

    var hiddenButtons = selectorScroller.querySelectorAll('.btn.hidden');
    for (var i = 0; i < hiddenButtons.length; i += 1) {
      hiddenButtons[i].classList.remove('hidden');
    }

    var expander = selectorScroller.querySelector('.related-collection-links__expander');
    if (expander && expander.parentNode) {
      expander.parentNode.removeChild(expander);
    }
  };

  var updateMobileSliderState = function(sectionElement) {
    if (!sectionElement || !sectionElement.querySelector) { return; }
    var sliderRoot = sectionElement.querySelector('[data-tfx-fc-overlay-root].slider');
    if (!sliderRoot || !window.matchMedia('(max-width: 767.98px)').matches) {
      sectionElement.removeAttribute('data-tfx-fc-mobile-slider-active');
      return;
    }

    var overflowState = getTrackOverflowState(sliderRoot);
    if (overflowState.hasOverflow) {
      sectionElement.setAttribute('data-tfx-fc-mobile-slider-active', 'true');
    } else {
      sectionElement.removeAttribute('data-tfx-fc-mobile-slider-active');
    }
  };

  var restoreSelectorScroll = function(sectionElement, scrollLeft) {
    if (!sectionElement || typeof scrollLeft !== 'number') { return; }
    var selectorScroller = getSelectorScroller(sectionElement);
    if (!selectorScroller) { return; }
    if (Math.abs(selectorScroller.scrollLeft - scrollLeft) < 1) { return; }
    selectorScroller.scrollLeft = scrollLeft;
    requestAnimationFrame(function() {
      selectorScroller.scrollLeft = scrollLeft;
    });
  };

  var refreshSectionPresentation = function(sectionId) {
    if (typeof window.tfxInitFeaturedCollectionPresentation !== 'function') { return; }
    requestAnimationFrame(function() {
      window.tfxInitFeaturedCollectionPresentation(sectionId);
    });
  };

  var refreshNativeCarousel = function(sectionElement) {
    if (!sectionElement || !sectionElement.querySelector) { return; }
    var carouselElement = sectionElement.querySelector('carousel-slider');
    if (!carouselElement || typeof carouselElement.refresh !== 'function') { return; }
    carouselElement.refresh();
  };

  var ensureSliderItemsVisible = function(sectionElement) {
    if (!sectionElement || !sectionElement.querySelector) { return; }
    var sliderGrid = sectionElement.querySelector('[data-tfx-fc-overlay-root] .slider__grid');
    if (!sliderGrid) { return; }
    var sliderItems = sliderGrid.querySelectorAll('.slider__item');
    if (!sliderItems.length) { return; }
    var hasVisible = false;
    for (var i = 0; i < sliderItems.length; i += 1) {
      if (!sliderItems[i].hasAttribute('hidden')) {
        hasVisible = true;
        break;
      }
    }
    if (hasVisible) { return; }
    for (var j = 0; j < sliderItems.length; j += 1) {
      sliderItems[j].removeAttribute('hidden');
    }
  };

  var commitSectionContent = function(sectionElement, sectionId, collectionHandle, fetchedContent, markup, selectorScrollLeft, shouldCache) {
    if (!sectionElement || !fetchedContent || typeof markup !== 'string') { return false; }
    var currentContent = sectionElement.querySelector('[data-tfx-fc-dynamic-related-content]');
    if (!currentContent) { return false; }
    var activeHandle = sectionElement.getAttribute('data-tfx-fc-active-collection-handle') || '';
    var contentChanged = currentContent.innerHTML !== markup;

    if (contentChanged) {
      currentContent.innerHTML = markup;
    }
    restoreSelectorScroll(sectionElement, selectorScrollLeft);
    sectionElement.setAttribute('data-tfx-fc-active-collection-handle', collectionHandle);

    var state = getSectionState(sectionId);
    if (shouldCache && state) {
      setCachedMarkup(state, collectionHandle, markup);
    }

    normalizeSelectorButtons(sectionElement);
    updateSelectorActiveState(sectionElement, collectionHandle);
    updateMobileSliderState(sectionElement);
    resetCarouselToStart(sectionElement);
    ensureSliderItemsVisible(sectionElement);
    if (contentChanged || activeHandle !== collectionHandle) {
      refreshNativeCarousel(sectionElement);
      setTimeout(function() {
        resetCarouselToStart(sectionElement);
        ensureSliderItemsVisible(sectionElement);
        updateMobileSliderState(sectionElement);
      }, 140);
    }
    bindSideNav(sectionElement);
    refreshSectionPresentation(sectionId);
    return true;
  };

  var cacheCurrentMarkup = function(sectionElement) {
    if (!sectionElement) { return; }
    var sectionId = sectionElement.getAttribute('data-section-id');
    if (!sectionId) { return; }
    var state = getSectionState(sectionId);
    if (!state) { return; }
    var activeHandle = sectionElement.getAttribute('data-tfx-fc-active-collection-handle');
    if (!activeHandle) { return; }
    var content = sectionElement.querySelector('[data-tfx-fc-dynamic-related-content]');
    if (!content) { return; }
    setCachedMarkup(state, activeHandle, content.innerHTML);
  };

  var applySectionContent = function(sectionElement, sectionId, collectionHandle, fetchedSection) {
    if (!sectionElement || !fetchedSection) { return false; }
    var previousSelectorScroller = getSelectorScroller(sectionElement);
    var previousSelectorScrollLeft = previousSelectorScroller ? previousSelectorScroller.scrollLeft : null;
    var fetchedContent = fetchedSection.querySelector('[data-tfx-fc-dynamic-related-content]');
    if (!fetchedContent) { return false; }

    var fetchedMarkup = fetchedContent.innerHTML;
    var fetchedHasCards = contentHasProductCards(fetchedContent);

    if (!fetchedHasCards) {
      var state = getSectionState(sectionId);
      var fallbackMarkup = state ? getCachedMarkup(state, collectionHandle) : null;
      if (fallbackMarkup && markupHasProductCards(fallbackMarkup)) {
        var fallbackSection = buildVirtualSectionFromMarkup(fallbackMarkup);
        var fallbackContent = fallbackSection ? fallbackSection.querySelector('[data-tfx-fc-dynamic-related-content]') : null;
        if (!fallbackContent) { return false; }
        return commitSectionContent(sectionElement, sectionId, collectionHandle, fallbackContent, fallbackMarkup, previousSelectorScrollLeft, true);
      }
      return false;
    }

    return commitSectionContent(sectionElement, sectionId, collectionHandle, fetchedContent, fetchedMarkup, previousSelectorScrollLeft, true);
  };

  var fetchSectionForCollection = function(requestUrl, sectionId, collectionHandle, signal) {
    return fetch(requestUrl.toString(), { credentials: 'same-origin', signal: signal })
      .then(function(response) {
        if (!response.ok) { return null; }
        return response.text();
      })
      .then(function(html) {
        var fetchedSection = parseFetchedSection(html, sectionId);
        if (!fetchedSection) { return null; }
        var fetchedHandle = fetchedSection.getAttribute('data-tfx-fc-active-collection-handle') || '';
        if (collectionHandle && fetchedHandle && fetchedHandle !== collectionHandle) { return null; }
        return fetchedSection;
      })
      .catch(function(error) {
        if (error && error.name === 'AbortError') { throw error; }
        return null;
      });
  };

  var fetchedSectionHasCards = function(fetchedSection) {
    if (!fetchedSection || !fetchedSection.querySelector) { return false; }
    var fetchedContent = fetchedSection.querySelector('[data-tfx-fc-dynamic-related-content]');
    if (!fetchedContent) { return false; }
    return contentHasProductCards(fetchedContent);
  };

  var loadSectionForCollection = function(sectionId, collectionHandle, collectionUrl, signal) {
    var sectionElement = findSection(sectionId);
    var useDefaultRenderMode = isDefaultCollectionHandle(sectionElement, collectionHandle);
    var primaryUrl = buildRequestUrl(window.location.href, sectionId, collectionHandle, useDefaultRenderMode);
    if (!primaryUrl) { return Promise.resolve(null); }

    return fetchSectionForCollection(primaryUrl, sectionId, collectionHandle, signal)
      .then(function(fetchedSection) {
        var fallbackUrl = collectionUrl ? buildRequestUrl(collectionUrl, sectionId, collectionHandle, useDefaultRenderMode) : null;
        var shouldTryFallback = !!fallbackUrl && (
          !fetchedSection ||
          !fetchedSectionHasCards(fetchedSection)
        );

        if (!shouldTryFallback) {
          return fetchedSection;
        }

        return fetchSectionForCollection(fallbackUrl, sectionId, collectionHandle, signal)
          .then(function(fallbackSection) {
            if (fallbackSection && fetchedSectionHasCards(fallbackSection)) {
              return fallbackSection;
            }
            return fetchedSection || fallbackSection;
          });
      });
  };

  var buildVirtualSectionFromMarkup = function(markup) {
    if (typeof markup !== 'string') { return null; }
    var virtualSection = document.createElement('div');
    virtualSection.innerHTML = '<div data-tfx-fc-dynamic-related-content>' + markup + '</div>';
    return virtualSection;
  };

  var applyCachedCollection = function(sectionElement, sectionId, state, collectionHandle) {
    if (!state) { return false; }
    var cachedMarkup = getCachedMarkup(state, collectionHandle);
    if (!cachedMarkup) { return false; }
    var cachedSection = buildVirtualSectionFromMarkup(cachedMarkup);
    if (!cachedSection) { return false; }
    var cachedContent = cachedSection.querySelector('[data-tfx-fc-dynamic-related-content]');
    if (!cachedContent || !contentHasVisibleProductCards(cachedContent)) { return false; }
    return applySectionContent(sectionElement, sectionId, collectionHandle, cachedSection);
  };

  var fetchAndApplyCollection = function(sectionElement, sectionId, state, collectionHandle, collectionUrl, currentSeq, signal) {
    return loadSectionForCollection(sectionId, collectionHandle, collectionUrl, signal)
      .then(function(fetchedSection) {
        if (currentSeq !== state.requestSeq) { return false; }
        if (!fetchedSection) { return false; }
        return applySectionContent(sectionElement, sectionId, collectionHandle, fetchedSection);
      })
      .catch(function(error) {
        if (error && error.name === 'AbortError') { return false; }
        return false;
      });
  };

  var prefetchCollection = function(sectionElement, collectionHandle, collectionUrl) {
    if (!sectionElement || !collectionHandle) { return Promise.resolve(null); }
    if (!isInlineSwitchEnabled(sectionElement)) { return Promise.resolve(null); }
    if (window.Shopify && window.Shopify.designMode) { return Promise.resolve(null); }
    if (shouldSkipPrefetch()) { return Promise.resolve(null); }

    var sectionId = sectionElement.getAttribute('data-section-id');
    if (!sectionId) { return Promise.resolve(null); }
    var state = getSectionState(sectionId);
    if (!state) { return Promise.resolve(null); }
    if (getCachedMarkup(state, collectionHandle)) { return Promise.resolve(true); }
    if (state.prefetching[collectionHandle]) { return state.prefetching[collectionHandle]; }

    state.prefetching[collectionHandle] = loadSectionForCollection(sectionId, collectionHandle, collectionUrl, null)
      .then(function(fetchedSection) {
        if (!fetchedSection) { return false; }
        var fetchedContent = fetchedSection.querySelector('[data-tfx-fc-dynamic-related-content]');
        if (!fetchedContent) { return false; }
        setCachedMarkup(state, collectionHandle, fetchedContent.innerHTML);
        return true;
      })
      .catch(function() {
        return false;
      });

    state.prefetching[collectionHandle] = state.prefetching[collectionHandle].then(function(result) {
        delete state.prefetching[collectionHandle];
        return result;
      });

    return state.prefetching[collectionHandle];
  };

  var prefetchTopCollections = function(sectionElement) {
    if (!sectionElement) { return; }
    if (!isInlineSwitchEnabled(sectionElement)) { return; }
    if (window.Shopify && window.Shopify.designMode) { return; }
    if (shouldSkipPrefetch()) { return; }
    if (sectionElement.dataset.tfxFcPrefetchInit === 'true') { return; }
    sectionElement.dataset.tfxFcPrefetchInit = 'true';

    var activeHandle = sectionElement.getAttribute('data-tfx-fc-active-collection-handle');
    var buttons = sectionElement.querySelectorAll('[data-tfx-fc-switch-collection]');
    var queue = [];
    var seenHandles = {};
    for (var i = 0; i < buttons.length; i += 1) {
      var handle = buttons[i].getAttribute('data-tfx-fc-switch-collection');
      var href = buttons[i].getAttribute('href');
      if (!handle || handle === activeHandle || seenHandles[handle]) { continue; }
      seenHandles[handle] = true;
      queue.push({ handle: handle, href: href });
      if (queue.length >= CONFIG.prefetchLimit) { break; }
    }
    if (!queue.length) { return; }

    var runPrefetchQueue = function(list) {
      list.forEach(function(item) {
        prefetchCollection(sectionElement, item.handle, item.href);
      });
    };

    var eagerQueue = queue.slice(0, CONFIG.prefetchEagerCount);
    var idleQueue = queue.slice(CONFIG.prefetchEagerCount);

    if (eagerQueue.length) {
      runPrefetchQueue(eagerQueue);
    }

    if (!idleQueue.length) { return; }

    var runIdlePrefetch = function() {
      runPrefetchQueue(idleQueue);
    };

    if ('requestIdleCallback' in window) {
      window.requestIdleCallback(runIdlePrefetch, { timeout: CONFIG.prefetchIdleTimeout });
    } else {
      setTimeout(runIdlePrefetch, CONFIG.prefetchFallbackDelay);
    }
  };

  var switchSectionCollection = function(sectionElement, collectionHandle, collectionUrl) {
    if (!sectionElement || !collectionHandle) { return; }
    if (!isInlineSwitchEnabled(sectionElement)) { return; }

    var sectionId = sectionElement.getAttribute('data-section-id');
    if (!sectionId) { return; }
    var state = getSectionState(sectionId);
    if (!state) { return; }

    var activeHandle = sectionElement.getAttribute('data-tfx-fc-active-collection-handle') || '';
    if (activeHandle === collectionHandle) {
      resetCarouselToStart(sectionElement);
      ensureSliderItemsVisible(sectionElement);
      bindSideNav(sectionElement);
      if (sectionHasRenderableProductCards(sectionElement) && sectionHasVisibleCardInViewport(sectionElement)) {
        return;
      }
    }

    var canUseCache = !isDefaultCollectionHandle(sectionElement, collectionHandle);
    if (canUseCache && applyCachedCollection(sectionElement, sectionId, state, collectionHandle)) {
      return;
    }

    state.requestSeq += 1;
    var currentSeq = state.requestSeq;
    var finalizeSwitch = function() {
      if (currentSeq !== state.requestSeq) { return; }
      sectionElement.dataset.tfxFcInlineSwitchLoading = 'false';
      state.controller = null;
    };

    sectionElement.dataset.tfxFcInlineSwitchLoading = 'true';

    if (state.controller && typeof state.controller.abort === 'function') {
      state.controller.abort();
    }
    state.controller = (typeof AbortController !== 'undefined') ? new AbortController() : null;

    fetchAndApplyCollection(sectionElement, sectionId, state, collectionHandle, collectionUrl, currentSeq, state.controller ? state.controller.signal : null)
      .then(function() {
        finalizeSwitch();
      });
  };

  var initSection = function(sectionElement) {
    if (!sectionElement) { return; }
    bindSideNav(sectionElement);
    if (!isInlineSwitchEnabled(sectionElement)) { return; }
    sectionElement.dataset.tfxFcInlineSwitchLoading = 'false';
    normalizeSelectorButtons(sectionElement);
    cacheCurrentMarkup(sectionElement);
    prefetchTopCollections(sectionElement);
    updateSelectorActiveState(sectionElement, sectionElement.getAttribute('data-tfx-fc-active-collection-handle') || '');
    updateMobileSliderState(sectionElement);
  };

  window.tfxReinitFeaturedCollectionInteractive = function(sectionId) {
    if (sectionId) {
      initSection(findSection(sectionId));
      return;
    }
    getAllSections().forEach(function(sectionElement) {
      initSection(sectionElement);
    });
  };

  getAllSections().forEach(function(sectionElement) {
    initSection(sectionElement);
  });

  document.addEventListener('click', function(event) {
    var switchTarget = getSwitchTarget(event);
    if (switchTarget) {
      event.preventDefault();
      switchSectionCollection(switchTarget.sectionElement, switchTarget.collectionHandle, switchTarget.collectionUrl);
    }
  });

  document.addEventListener('mouseenter', function(event) {
    var target = getSwitchTarget(event);
    if (!target) { return; }
    prefetchCollection(target.sectionElement, target.collectionHandle, target.collectionUrl);
  }, true);

  document.addEventListener('touchstart', function(event) {
    var target = getSwitchTarget(event);
    if (!target) { return; }
    prefetchCollection(target.sectionElement, target.collectionHandle, target.collectionUrl);
  }, { passive: true, capture: true });

  document.addEventListener('shopify:section:load', function(event) {
    if (!event.detail || !event.detail.sectionId) { return; }
    var sectionElement = findSection(event.detail.sectionId);
    initSection(sectionElement);
  });

  if (!window.__tfxFcSideNavResizeBound) {
    document.addEventListener('on:debounced-resize', function() {
      getAllSections().forEach(function(sectionElement) {
        refreshNativeCarousel(sectionElement);
        ensureSliderItemsVisible(sectionElement);
        updateMobileSliderState(sectionElement);
        bindSideNav(sectionElement);
        updateSideNavState(sectionElement);
      });
    });
    window.__tfxFcSideNavResizeBound = true;
  }
})();
/* END TFX_FC_INLINE_COLLECTION_SWITCH_JS */
